import { render, staticRenderFns } from "./Chart2.vue?vue&type=template&id=dc674168&scoped=true&"
import script from "./Chart2.js?vue&type=script&lang=js&"
export * from "./Chart2.js?vue&type=script&lang=js&"
import style0 from "./Chart2.vue?vue&type=style&index=0&id=dc674168&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc674168",
  null
  
)

export default component.exports